var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGamepadSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7922 3.94928H8.15512C4.43447 3.94928 1.41828 7.03137 1.41828 10.8333C1.41828 14.6353 4.43447 17.7174 8.15512 17.7174H18.7922C22.5129 17.7174 25.5291 14.6353 25.5291 10.8333C25.5291 7.03137 22.5129 3.94928 18.7922 3.94928ZM8.15512 2.5C3.65117 2.5 0 6.23096 0 10.8333C0 15.4357 3.65117 19.1667 8.15512 19.1667H18.7922C23.2962 19.1667 26.9474 15.4357 26.9474 10.8333C26.9474 6.23096 23.2962 2.5 18.7922 2.5H8.15512Z",
    fill: "url(#paint0_linear_1673_11680)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8421 6.66699C9.26067 6.66699 9.6 7.00278 9.6 7.41699V9.66699H11.8737C12.2923 9.66699 12.6316 10.0028 12.6316 10.417C12.6316 10.8312 12.2923 11.167 11.8737 11.167H9.6V13.417C9.6 13.8312 9.26067 14.167 8.8421 14.167C8.42353 14.167 8.08421 13.8312 8.08421 13.417V11.167H5.81052C5.39195 11.167 5.05263 10.8312 5.05263 10.417C5.05263 10.0028 5.39195 9.66699 5.81052 9.66699H8.08421V7.41699C8.08421 7.00278 8.42353 6.66699 8.8421 6.66699Z",
    fill: "url(#paint1_linear_1673_11680)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7368 8.33366C22.7368 9.25413 21.9828 10.0003 21.0526 10.0003C20.1225 10.0003 19.3684 9.25413 19.3684 8.33366C19.3684 7.41318 20.1225 6.66699 21.0526 6.66699C21.9828 6.66699 22.7368 7.41318 22.7368 8.33366Z",
    fill: "url(#paint2_linear_1673_11680)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2105 13.3337C20.2105 14.2541 19.4565 15.0003 18.5263 15.0003C17.5961 15.0003 16.8421 14.2541 16.8421 13.3337C16.8421 12.4132 17.5961 11.667 18.5263 11.667C19.4565 11.667 20.2105 12.4132 20.2105 13.3337Z",
    fill: "url(#paint3_linear_1673_11680)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1673_11680",
    x1: 1.66196e-8,
    y1: 11.3889,
    x2: 26.9474,
    y2: 11.3889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1673_11680",
    x1: 5.05263,
    y1: 10.667,
    x2: 12.6316,
    y2: 10.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1673_11680",
    x1: 19.3684,
    y1: 8.44477,
    x2: 22.7368,
    y2: 8.44477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1673_11680",
    x1: 16.8421,
    y1: 13.4448,
    x2: 20.2105,
    y2: 13.4448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamepadSolid);
export default __webpack_public_path__ + "static/media/gamepad-solid.9255e2d69daf0f6372a889b72c46e366.svg";
export { ForwardRef as ReactComponent };